import { Grid } from "@mui/material";
import { useUser } from "../../../hooks/useUser";
import { useReadCurrentUserVehiclesQuery, useReadUsersVehiclesQuery } from "../../../state/api/vehicle.api";
import { Vehicle } from "../../../types/Vehicle";
import { VehicleGridTable } from "../view/vehicleGridTable";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "../../shared/PageHeader";
import { GridItemAdd } from "../../shared/addNew/gridItemAdd";
import { AddCircle } from "@mui/icons-material";
import { ListingType } from "../../../enum/vehicleListing.enum";

export const OwnVehicleViewContainer = () => {
    const user = useUser();
    const navigate = useNavigate();

    const { data: data1 } = useReadCurrentUserVehiclesQuery({UserId: Number(user.user.id)});
    const { data: data2 } = useReadUsersVehiclesQuery({UserId: Number(user.user.id)});

    const handleSelect = (vid: number) => {
        const path = `/vehicle/${vid}/cache`;
        navigate(path);
    };

    const handleAddVehicle = () => {
        navigate(`/vehicle/create?vehicleListing=${ListingType.ListingForMyOwn}`);
    }

    return <div>
        <PageHeader header={"Your Owned Vehicles"} subHeader={"Maintain The Service Records For Your Vehicle"} showEditOptions={false} />
        <GridItemAdd Icon={AddCircle} text="Add Vehicle" subText={''} onAdd={handleAddVehicle} />
        <Grid container spacing={1}>
            {
                data1?.map((v: Vehicle) => (
                    <VehicleGridTable
                        vehicle={v} key={`${v.id}${v.createdAt.toString()}`}
                        onSelect={() => handleSelect(v.id)} />
                ))
            }
            {
                data2?.map((v: Vehicle) => (
                    <VehicleGridTable
                        vehicle={v} key={`${v.id}${v.createdAt.toString()}`}
                        onSelect={() => handleSelect(v.id)} />
                ))
            }
        </Grid>
    </div>
}